<template>
  <div class="h-100 hvh-flex center p-5">
    <v-form class="col-12 col-lg-6 mt-5" ref="form">
      <v-text-field
        v-model="newPassword"
        :append-icon="passwordHide ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="() => (passwordHide = !passwordHide)"
        :type="passwordHide ? 'password' : 'text'"
        :rules="passwordRules"
        name="Password"
        label="New Password"
        hint="At least 6 characters"
        min="6"
        max="100"
        counter
      />
      <v-text-field
        v-model="confirmPassword"
        :append-icon="passwordHide ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="() => (passwordHide = !passwordHide)"
        :type="passwordHide ? 'password' : 'text'"
        :rules="confirmPasswordRules"
        name="ConfirmPassword"
        label="Confirm Password"
        hint="At least 6 characters"
        min="6"
        max="100"
        counter
      />

      <v-btn flat block large class="hvh-btn hvh-btn--primary mt-5" @click="submit">Create Password</v-btn>
    </v-form>
    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import axios from '../../axios';
import Loader from '../../components/common/loader/Loader.vue';
import { createFormData, errorDebug } from '../../libraries/common';
export default {
  components: { Loader, },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      passwordHide: true,
      isLoading: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Password must be at least 6 characters',
        v => v.length <= 100 || 'Password must be not more than 100 characters',
        v => v.toUpperCase() != v || 'Password must contain at least one lowercase letter.',
        v => v.toLowerCase() != v || 'Password must contain at least one uppercase letter.',
        v => /[^a-zA-Z\d\s:]/.test(v) || 'Password must have at least one non alphanumeric character.'
      ],
      confirmPasswordRules: [
        v => !!v || 'Password is required',
        v => v === this.newPassword || 'The password and confirmation password do not match.',
      ],
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    passwordToken() {
      return this.$route.query.token;
    },
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      axios.post(`/api/ITM/CustomerAccess/${this.token}/CreatePassword`, createFormData({ passwordToken: this.passwordToken, password: this.newPassword, }))
        .then(({ data }) => {
          sessionStorage.setItem('customerToken', data.jwtToken);
          this.$router.replace({ name: 'itmCustomerAccess', params: { token: this.token } });
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCustomerAccessCreatePassword'] = this;
  },
}
</script>
